import { createStore } from "vuex";

import AccountAreaToastStore from "@Account/Scripts/Stores/AccountAreaToastStore";
import PrivateAreaBundleEmailStore from "@PrivateArea/Scripts/Stores/PrivateAreaBundleEmailStore";
import ProjectAssociationStore from "@PrivateArea/Scripts/Stores/ProjectAssociationStore";

export const store = createStore({
    modules: {
        "accountAreaToastStore": AccountAreaToastStore,
        "privateAreaBundleEmailStore": PrivateAreaBundleEmailStore,
        "projectAssociationStore": ProjectAssociationStore
    }
});